import { render, staticRenderFns } from "./FooterLink.vue?vue&type=template&id=3bd8cae6&scoped=true"
import script from "./FooterLink.vue?vue&type=script&lang=js"
export * from "./FooterLink.vue?vue&type=script&lang=js"
import style0 from "./FooterLink.vue?vue&type=style&index=0&id=3bd8cae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8cae6",
  null
  
)

export default component.exports